(function() {
    "use strict";

    var scheduleIdle = window.requestIdleCallback ?
        function(fn) {
            window.requestIdleCallback(fn, {
                timeout: 200
            });
        } :
        function(fn) {
            setTimeout(fn, 200);
        };

    (function() {
        var scrollTick = false;
        var headerSticky = document.getElementById('header-sticky');

        function onScrollTick() {
            scrollTick = false;
            var scroll = window.pageYOffset || document.documentElement.scrollTop;
            if (headerSticky) {
                if (scroll < 70) {
                    headerSticky.classList.remove("header-sticky");
                } else {
                    headerSticky.classList.add("header-sticky");
                }
            }
        }
        window.addEventListener('scroll', function() {
            if (!scrollTick) {
                scrollTick = true;
                requestAnimationFrame(onScrollTick);
            }
        }, {
            passive: true
        });
    })();

    document.addEventListener("DOMContentLoaded", function() {
        var menuBar = document.querySelector(".xo-menu-bar");
        var offcanvas = document.querySelector(".xo-offcanvas");
        var bodyOverlay = document.querySelector(".body-overlay");
        var closeBtn = document.querySelector(".close-btn");

        function openOffcanvas() {
            if (offcanvas) offcanvas.classList.add("opened");
            if (bodyOverlay) bodyOverlay.classList.add("apply");
        }

        function closeOffcanvas() {
            if (offcanvas) offcanvas.classList.remove("opened");
            if (bodyOverlay) bodyOverlay.classList.remove("apply");
        }
        if (menuBar) menuBar.addEventListener("click", openOffcanvas);
        if (closeBtn) closeBtn.addEventListener("click", closeOffcanvas);
        if (bodyOverlay) bodyOverlay.addEventListener("click", closeOffcanvas);
    });

    window.addEventListener("load", function() {
        scheduleIdle(function() {
            initDeferred();
        });
    });

    function initDeferred() {
        initOffcanvasSubmenus();
        observeAndInitMagicCursor();
        observeAndInitGSAP();
        observeAndInitFade();
        observeAndInitTextReveal();
        observeAndInitBounce();
        observeAndInitSnapSlider();
        observeAndInitPureCounter();
        observeAndInitTextInvert();
        observeAndInitBlogHover();
        initDataBackground();
    }

    function initOffcanvasSubmenus() {
        function slideDown(element, duration) {
            duration = duration || 400;
            element.style.display = 'block';
            element.style.overflow = 'hidden';
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var height = element.scrollHeight;
                    element.style.height = '0px';
                    element.style.transition = 'height ' + duration + 'ms ease';
                    requestAnimationFrame(function() {
                        element.style.height = height + 'px';
                        setTimeout(function() {
                            element.style.height = 'auto';
                            element.style.transition = '';
                        }, duration);
                    });
                });
            });
        }

        function slideUp(element, duration) {
            duration = duration || 400;
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    var height = element.scrollHeight;
                    element.style.height = height + 'px';
                    element.style.overflow = 'hidden';
                    element.style.transition = 'height ' + duration + 'ms ease';
                    requestAnimationFrame(function() {
                        element.style.height = '0px';
                        setTimeout(function() {
                            element.style.display = 'none';
                            element.style.height = '';
                            element.style.overflow = '';
                            element.style.transition = '';
                        }, duration);
                    });
                });
            });
        }
        var sideMenuList = document.querySelectorAll('.xo-offcanvas-menu nav > ul > li button.xo-menu-close, .xo-offcanvas-menu nav > ul li.has-dropdown > a, .xo-offcanvas-menu nav > ul li.has-dropdown > ul > li.menu-item-has-children > a');
        for (var i = 0; i < sideMenuList.length; i++) {
            (function(item) {
                item.addEventListener('click', function(e) {
                    e.preventDefault();
                    var parent = item.parentElement;
                    var submenu = parent ? parent.querySelector('.xo-submenu, .mega-menu') : null;
                    if (!submenu) return;
                    if (!parent.classList.contains('active')) {
                        parent.classList.add('active');
                        slideDown(submenu);
                    } else {
                        slideUp(submenu);
                        parent.classList.remove('active');
                    }
                });
            })(sideMenuList[i]);
        }
        // var offcanvasArea = document.querySelector('.xo-offcanvas-area');
        // if (offcanvasArea) {
        //     var firstDropdown = offcanvasArea.querySelector('.has-dropdown');
        //     if (firstDropdown) {
        //         var submenu = firstDropdown.querySelector('.xo-submenu, .mega-menu');
        //         if (submenu) {
        //             firstDropdown.classList.add('active');
        //             slideDown(submenu);
        //         }
        //     }
        // }
    }

    function observeAndInitMagicCursor() {
        if (document.body.classList.contains("is-mobile") || !document.body.classList.contains("xo-magic-cursor")) return;
        var ball = document.getElementById("ball");
        if (!ball) return;
        var run = function() {
            initMagicCursor();
        };
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                run();
            }, {
                rootMargin: "0px",
                threshold: 0
            });
            io.observe(document.body);
        } else {
            run();
        }
    }

    function initMagicCursor() {
        if (typeof gsap === "undefined") {
            setTimeout(initMagicCursor, 100);
            return;
        }
        requestAnimationFrame(function() {
            document.querySelectorAll(".xo-magnetic-item").forEach((item) => {
                if (!item.parentElement || !item.parentElement.classList.contains("xo-magnetic-wrap")) {
                    const wrapper = document.createElement("div");
                    wrapper.className = "xo-magnetic-wrap";
                    item.parentNode?.insertBefore(wrapper, item);
                    wrapper.appendChild(item);
                }
            });

            document.querySelectorAll("a.xo-magnetic-item").forEach((link) => {
                link.classList.add("not-hide-cursor");
            });

            const mouse = {
                x: 0,
                y: 0
            };
            const pos = {
                x: 0,
                y: 0
            };
            const ratio = 0.15;
            let isActive = false;
            const ball = document.getElementById("ball");

            if (!ball) return;

            const ballWidth = 14;
            const ballHeight = 14;
            const ballScale = 1;
            const ballOpacity = 1;
            const ballBorderWidth = 1;

            gsap.set(ball, {
                xPercent: -50,
                yPercent: -50,
                width: ballWidth,
                height: ballHeight,
                borderWidth: ballBorderWidth,
                opacity: ballOpacity,
            });

            document.addEventListener("mousemove", (event) => {
                mouse.x = event.clientX;
                mouse.y = event.clientY;
            });

            gsap.ticker.add(() => {
                if (!isActive) {
                    pos.x += (mouse.x - pos.x) * ratio;
                    pos.y += (mouse.y - pos.y) * ratio;
                    gsap.set(ball, {
                        x: pos.x,
                        y: pos.y
                    });
                }
            });

            const magneticWraps = document.querySelectorAll(".xo-magnetic-wrap");
            const parallaxIt = (event, parent, target, movement) => {
                if (!target) return;
                const clientX = event.clientX;
                const clientY = event.clientY;
                requestAnimationFrame(() => {
                    const r = parent.getBoundingClientRect();
                    const relX = clientX - r.left;
                    const relY = clientY - r.top;
                    gsap.to(target, {
                        duration: 0.3,
                        x: ((relX - r.width / 2) / r.width) * movement,
                        y: ((relY - r.height / 2) / r.height) * movement,
                        ease: "power2.out",
                    });
                });
            };

            const parallaxCursor = (event, parent, movement) => {
                const clientX = event.clientX;
                const clientY = event.clientY;
                requestAnimationFrame(() => {
                    const r = parent.getBoundingClientRect();
                    const relX = clientX - r.left;
                    const relY = clientY - r.top;
                    pos.x = r.left + r.width / 2 + (relX - r.width / 2) / movement;
                    pos.y = r.top + r.height / 2 + (relY - r.height / 2) / movement;
                    gsap.to(ball, {
                        duration: 0.3,
                        x: pos.x,
                        y: pos.y
                    });
                });
            };

            magneticWraps.forEach((wrap) => {
                wrap.addEventListener("mousemove", (event) => {
                    parallaxCursor(event, wrap, 2);
                    parallaxIt(event, wrap, wrap.querySelector(".xo-magnetic-item"), 25);
                });

                wrap.addEventListener("mouseenter", () => {
                    gsap.to(ball, {
                        duration: 0.3,
                        scale: 2,
                        borderWidth: 1,
                        opacity: ballOpacity
                    });
                    isActive = true;
                });

                wrap.addEventListener("mouseleave", () => {
                    gsap.to(ball, {
                        duration: 0.3,
                        scale: ballScale,
                        borderWidth: ballBorderWidth,
                        opacity: ballOpacity,
                    });
                    const target = wrap.querySelector(".xo-magnetic-item");
                    if (target) {
                        gsap.to(target, {
                            duration: 0.3,
                            x: 0,
                            y: 0,
                            clearProps: "all"
                        });
                    }
                    isActive = false;
                });
            });

            const isRtl = () => document.documentElement.getAttribute("dir") === "rtl";

            requestAnimationFrame(function() {
                var elements = document.querySelectorAll("[data-cursor]");
                var cursorColors = [];
                for (var i = 0; i < elements.length; i++) {
                    cursorColors.push(
                        getComputedStyle(elements[i]).getPropertyValue("--cursor-color").trim() || "#fff"
                    );
                }
                requestAnimationFrame(function() {
                    for (var i = 0; i < elements.length; i++) {
                        (function(element, cursorColor) {
                            element.addEventListener("mouseenter", () => {
                                // Remove any existing ball-view before creating a new one
                                const existingView = ball.querySelector(".ball-view");
                                if (existingView) {
                                    existingView.remove();
                                }

                                ball.classList.add("with-blur");
                                const ballView = document.createElement("div");
                                ballView.className = "ball-view";
                                ballView.innerHTML = element.getAttribute("data-cursor") || "";
                                ball.appendChild(ballView);

                                gsap.to(ball, {
                                    duration: 0.3,
                                    xPercent: isRtl() ? 50 : -50,
                                    yPercent: -60,
                                    width: 110,
                                    height: 110,
                                    opacity: 1,
                                    borderWidth: 0,
                                    zIndex: 1,
                                    backdropFilter: "blur(14px)",
                                    backgroundColor: cursorColor || "#fff",
                                });

                                gsap.to(ballView, {
                                    duration: 0.3,
                                    scale: 1,
                                    autoAlpha: 1
                                });
                            });

                            element.addEventListener("mouseleave", () => {
                                ball.classList.remove("with-blur");

                                gsap.to(ball, {
                                    duration: 0.3,
                                    yPercent: -50,
                                    width: ballWidth,
                                    height: ballHeight,
                                    opacity: ballOpacity,
                                    borderWidth: ballBorderWidth,
                                    backgroundColor: "#000",
                                    backdropFilter: "none",
                                });

                                const existingView = ball.querySelector(".ball-view");
                                if (existingView) {
                                    gsap.to(existingView, {
                                        duration: 0.3,
                                        scale: 0,
                                        autoAlpha: 0,
                                        clearProps: "all",
                                        onComplete: () => {
                                            existingView.remove();
                                        },
                                    });
                                }
                            });

                            element.classList.add("not-hide-cursor");
                        }(elements[i], cursorColors[i]));
                    }
                });
            });

            document
                .querySelectorAll("a:not(.cursor-hide), button:not(.cursor-hide)")
                .forEach((el) => {
                    el.addEventListener("mouseenter", () => {
                        gsap.to(ball, {
                            duration: 0.3,
                            scale: 0,
                            opacity: 0
                        });
                    });
                    el.addEventListener("mouseleave", () => {
                        gsap.to(ball, {
                            duration: 0.3,
                            scale: ballScale,
                            opacity: ballOpacity
                        });
                    });
                });

            document.querySelectorAll("a").forEach((link) => {
                const skipClick =
                    link.target === "_blank" ||
                    link.classList.contains("cursor-hide") ||
                    link.matches('[href^="#"]') ||
                    link.matches('[href^="mailto"]') ||
                    link.matches('[href^="tel"]') ||
                    link.classList.contains("lg-trigger") ||
                    link.closest(".xo-btn-disabled");

                if (!skipClick) {
                    link.addEventListener("click", () => {
                        gsap.to(ball, {
                            duration: 0.3,
                            scale: 1.3,
                            autoAlpha: 0
                        });
                    });
                }
            });

            const magicCursor = document.getElementById("magic-cursor");
            if (magicCursor) {
                const toggleCursorVisibility = (opacity) => {
                    gsap.to(magicCursor, {
                        duration: 0.3,
                        autoAlpha: opacity
                    });
                };

                document.addEventListener("mouseleave", () => toggleCursorVisibility(0));
                document.addEventListener("mouseenter", () => toggleCursorVisibility(1));
                document.addEventListener("mousemove", () => toggleCursorVisibility(1));
            }
        });
    }




    function observeAndInitGSAP() {
        var root = document.getElementById('smooth-wrapper') || document.body;

        function run() {
            requestAnimationFrame(function() {
                requestAnimationFrame(initGSAPAnimations);
            });
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                run();
            }, {
                rootMargin: "0px",
                threshold: 0
            });
            io.observe(root);
        } else {
            run();
        }
    }

    function initGSAPAnimations() {
        if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined" || typeof ScrollSmoother === "undefined") {
            setTimeout(initGSAPAnimations, 100);
            return;
        }

        if (window.xoScrollSmootherInitialized) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

        // Reduce unnecessary ScrollTrigger refreshes/reflows
        if (typeof ScrollTrigger !== "undefined" && ScrollTrigger.config) {
            ScrollTrigger.config({
                ignoreMobileResize: true,
                autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
            });
        }

        // Hint the browser that animated elements will change transform
        if (typeof gsap !== "undefined") {
            gsap.set("[data-animate]", {
                willChange: "transform"
            });
        }

        const smoothWrapper = document.getElementById('smooth-wrapper');
        const smoothContent = document.getElementById('smooth-content');
        if (smoothWrapper && smoothContent) {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isAndroid = /android/i.test(userAgent);
            const isIPhone = /iPhone/i.test(userAgent);
            const isAndroidOrIPhone = isAndroid || isIPhone;

            if (!isAndroidOrIPhone) {
                try {
                    ScrollSmoother.create({
                        wrapper: "#smooth-wrapper",
                        content: "#smooth-content",
                        smooth: 1,
                        effects: false,
                        normalizeScroll: true
                    });
                    window.xoScrollSmootherInitialized = true;
                } catch (e) {
                    console.warn('ScrollSmoother initialization failed:', e);
                }
            } else {
                // On mobile, do not modify wrapper inline styles to avoid layout shifts.
                window.xoScrollSmootherInitialized = true;
            }
        }

        document.querySelectorAll(".scrool-rotate-img").forEach(function(element) {
            gsap.to(element, {
                rotation: 720,
                ease: "power2.out",
                duration: 1,
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1.5,
                }
            });
        });

        document.querySelectorAll("[data-speed]").forEach(function(element) {
            const speedValue = parseFloat(element.getAttribute("data-speed"));
            if (isNaN(speedValue)) return;

            gsap.set(element, {
                y: 0,
                force3D: true
            });

            const viewportHeight = window.innerHeight;
            const parallaxDistance = speedValue * (viewportHeight * 0.2);

            gsap.to(element, {
                y: parallaxDistance,
                ease: "none",
                scrollTrigger: {
                    trigger: element,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1,
                    invalidateOnRefresh: true,
                }
            });
        });
    }




    function observeAndInitFade() {
        if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
        var items = document.querySelectorAll(".xo_fade_anim");
        if (items.length === 0) return;

        function initOne(item) {
            var xo_fade_offset = Number(item.getAttribute("data-fade-offset")) || 40;
            var xo_duration_value = item.getAttribute("data-duration") || 0.75;
            var xo_fade_direction = item.getAttribute("data-fade-from") || "bottom";
            var xo_onscroll_value = item.getAttribute("data-on-scroll") || 1;
            var xo_delay_value = item.getAttribute("data-delay") || 0.15;
            var xo_ease_value = item.getAttribute("data-ease") || "power2.out";
            var xo_anim_setting = {
                opacity: 0,
                ease: xo_ease_value,
                duration: xo_duration_value,
                delay: xo_delay_value,
                x: (xo_fade_direction === "left" ? -xo_fade_offset : (xo_fade_direction === "right" ? xo_fade_offset : 0)),
                y: (xo_fade_direction === "top" ? -xo_fade_offset : (xo_fade_direction === "bottom" ? xo_fade_offset : 0)),
            };
            if (xo_onscroll_value == 1) {
                xo_anim_setting.scrollTrigger = {
                    trigger: item,
                    start: 'top 95%'
                };
            }
            gsap.from(item, xo_anim_setting);
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                for (var i = 0; i < entries.length; i++) {
                    if (!entries[i].isIntersecting) continue;
                    var item = entries[i].target;
                    io.unobserve(item);
                    initOne(item);
                }
            }, {
                rootMargin: "50px 0px",
                threshold: 0
            });
            for (var j = 0; j < items.length; j++) io.observe(items[j]);
        } else {
            for (var k = 0; k < items.length; k++) initOne(items[k]);
        }
    }



    function observeAndInitTextReveal() {
        if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined" || typeof SplitText === "undefined") return;
        var list = document.querySelectorAll(".xo-text-revel-anim");
        if (list.length === 0) return;

        function initOne(areveal) {
            var getAttr = function(attr, def) {
                return areveal.getAttribute(attr) || def;
            };
            var duration_value = Number(getAttr("data-duration", 1));
            var onscroll_value = Number(getAttr("data-on-scroll", 1));
            var stagger_value = Number(getAttr("data-stagger", 0.02));
            var data_delay = Number(getAttr("data-delay", 0.08));
            var ease_value = getAttr("data-ease", "circ.out");
            areveal.split = new SplitText(areveal, {
                type: "lines,words,chars",
                linesClass: "xo-revel-line"
            });
            var animationProps = {
                duration: duration_value,
                delay: data_delay,
                ease: ease_value,
                y: 40,
                stagger: stagger_value,
                opacity: 0,
            };
            if (onscroll_value === 1) {
                animationProps.scrollTrigger = {
                    trigger: areveal,
                    start: 'top 95%'
                };
            }
            areveal.anim = gsap.from(areveal.split.chars, animationProps);
        }

        function run() {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function() {
                    if (typeof IntersectionObserver !== "undefined") {
                        var io = new IntersectionObserver(function(entries) {
                            for (var i = 0; i < entries.length; i++) {
                                if (!entries[i].isIntersecting) continue;
                                var el = entries[i].target;
                                io.unobserve(el);
                                initOne(el);
                            }
                        }, {
                            rootMargin: "50px 0px",
                            threshold: 0
                        });
                        for (var j = 0; j < list.length; j++) io.observe(list[j]);
                    } else {
                        for (var k = 0; k < list.length; k++) initOne(list[k]);
                    }
                });
            } else {
                if (typeof IntersectionObserver !== "undefined") {
                    var io = new IntersectionObserver(function(entries) {
                        for (var i = 0; i < entries.length; i++) {
                            if (!entries[i].isIntersecting) continue;
                            var el = entries[i].target;
                            io.unobserve(el);
                            initOne(el);
                        }
                    }, {
                        rootMargin: "50px 0px",
                        threshold: 0
                    });
                    for (var j = 0; j < list.length; j++) io.observe(list[j]);
                } else {
                    for (var k = 0; k < list.length; k++) initOne(list[k]);
                }
            }
        }
        run();
    }


    function observeAndInitPureCounter() {
        if (typeof PureCounter === "undefined") return;
        var root = document.body;

        function run() {
            new PureCounter();
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                run();
            }, {
                rootMargin: "0px",
                threshold: 0
            });
            io.observe(root);
        } else {
            run();
        }
    }



    function observeAndInitBounce() {
        var container = document.querySelector(".bounce_animation");
        if (!container) return;

        function run() {
            if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
            var bounceItems = document.querySelectorAll(".bounce_animation .bounce__anim");
            if (bounceItems.length === 0) return;
            var isNarrow = window.innerWidth < 1023;
            gsap.set(bounceItems, {
                y: -100,
                opacity: 0
            });
            if (isNarrow) {
                for (var i = 0; i < bounceItems.length; i++) {
                    var item = bounceItems[i];
                    var tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: item,
                            start: "top center+=200"
                        }
                    });
                    tl.to(item, {
                        y: 0,
                        opacity: 1,
                        ease: "bounce",
                        duration: 1.5
                    });
                }
            } else {
                gsap.to(bounceItems, {
                    scrollTrigger: {
                        trigger: ".bounce_animation",
                        start: "top center+=300"
                    },
                    y: 0,
                    opacity: 1,
                    ease: "bounce",
                    duration: 1.5,
                    stagger: {
                        each: 0.3
                    },
                });
            }
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                run();
            }, {
                rootMargin: "100px 0px",
                threshold: 0
            });
            io.observe(container);
        } else {
            run();
        }
    }




    function isMobile() {
        return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    function observeAndInitSnapSlider() {
        var holder = document.querySelector(".xo-snap-slider-holder");
        if (!holder) return;

        function run() {
            if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
            var snapSliderHolder = document.querySelector(".xo-snap-slider-holder");
            if (!snapSliderHolder) return;
            var snapSlides = Array.from(document.querySelectorAll(".xo-snap-slide"));
            var snapSlidesImgMask = Array.from(document.querySelectorAll(".xo-snap-slide .img-mask"));
            var snapCaptionWrapper = document.querySelector(".xo-snap-slider-captions");
            var snapCaptions = Array.from(document.querySelectorAll(".xo-snap-slide-caption"));
            var snapThumbsWrapper = document.querySelector(".xo-snap-slider-thumbs");
            var snapThumbs = Array.from(document.querySelectorAll(".thumb-slide"));
            if (snapSlides.length === 0) return;
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            var isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent) || window.innerWidth <= 768;
            var scrubValue = isMobile ? 2 : true;
            var viewportHeight = isMobile ? Math.max(document.documentElement.clientHeight, window.innerHeight) : window.innerHeight;
            var thumbHeight = snapThumbs[0] ? snapThumbs[0].offsetHeight : 0;
            var captionHeight = snapCaptions[0] ? snapCaptions[0].offsetHeight : 0;
            if (!isMobile) {
                gsap.fromTo(snapSlidesImgMask, {
                    opacity: 0.1
                }, {
                    duration: 1,
                    opacity: 1,
                    ease: "sine.out",
                    scrollTrigger: {
                        trigger: snapSliderHolder,
                        start: 'top 100%',
                        end: '+=100%',
                        scrub: scrubValue
                    },
                });
                gsap.fromTo(snapSlidesImgMask, {
                    opacity: 1
                }, {
                    duration: 1,
                    opacity: 0.1,
                    ease: "sine.out",
                    scrollTrigger: {
                        trigger: snapSliderHolder,
                        start: 'bottom 100%',
                        end: '+=100%',
                        scrub: scrubValue
                    },
                });
            }
            ScrollTrigger.create({
                trigger: snapSlides,
                start: "top top",
                end: "+=" + viewportHeight * (snapSlides.length - 1),
                pin: snapThumbsWrapper,
                scrub: scrubValue,
                pinSpacing: true,
                anticipatePin: isMobile ? 0 : 1,
            });
            gsap.fromTo(snapThumbs, {
                y: 0
            }, {
                y: -thumbHeight * (snapThumbs.length - 1),
                scrollTrigger: {
                    trigger: snapSliderHolder,
                    scrub: scrubValue,
                    start: "top top",
                    end: "+=" + viewportHeight * (snapSlides.length - 1)
                },
                ease: "none",
            });
            ScrollTrigger.create({
                trigger: snapCaptionWrapper,
                start: "top top",
                end: "+=" + viewportHeight * (snapSlides.length - 1),
                pin: true,
                scrub: scrubValue,
                pinSpacing: true,
                anticipatePin: isMobile ? 0 : 1,
            });
            gsap.fromTo(snapCaptions, {
                y: 0
            }, {
                y: -captionHeight * (snapCaptions.length - 1),
                scrollTrigger: {
                    trigger: snapSliderHolder,
                    scrub: scrubValue,
                    start: "top top",
                    end: "+=" + viewportHeight * (snapSlides.length - 1)
                },
                ease: "none",
            });
            for (var i = 0; i < snapSlides.length; i++) {
                var slide = snapSlides[i];
                var imageWrappers = slide.querySelectorAll(".img-mask");
                var isLastSlide = i === snapSlides.length - 1;
                var isFirstSlide = i === 0;
                if (isMobile) {
                    gsap.set(imageWrappers, {
                        y: 0,
                        clearProps: "transform"
                    });
                } else {
                    gsap.fromTo(imageWrappers, {
                        y: isFirstSlide ? 0 : -viewportHeight
                    }, {
                        y: isLastSlide ? 0 : viewportHeight,
                        scrollTrigger: {
                            trigger: slide,
                            scrub: scrubValue,
                            start: isFirstSlide ? "top top" : "top bottom",
                            end: isLastSlide ? "top top" : undefined
                        },
                        ease: "none",
                    });
                }
            }
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                requestAnimationFrame(function() {
                    requestAnimationFrame(run);
                });
            }, {
                rootMargin: "100px 0px",
                threshold: 0
            });
            io.observe(holder);
        } else {
            requestAnimationFrame(function() {
                requestAnimationFrame(run);
            });
        }
    }




    function observeAndInitBlogHover() {
        var bgImg = document.getElementById('xo-blogs-bg-img');
        var blogItems = document.querySelectorAll('.xo-blogs-item-images-js');
        if (blogItems.length === 0 || !bgImg) return;
        var root = bgImg.parentElement || document.body;

        function run() {
            for (var i = 0; i < blogItems.length; i++) {
                (function(item) {
                    item.addEventListener('mouseenter', function() {
                        for (var j = 0; j < blogItems.length; j++) blogItems[j].classList.remove('active');
                        item.classList.add('active');
                        var relValue = item.getAttribute('rel');
                        if (relValue) bgImg.className = relValue;
                    });
                })(blogItems[i]);
            }
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                run();
            }, {
                rootMargin: "50px 0px",
                threshold: 0
            });
            io.observe(root);
        } else {
            run();
        }
    }

    function initDataBackground() {
        var list = document.querySelectorAll('[data-background]');
        for (var i = 0; i < list.length; i++) {
            var bgUrl = list[i].getAttribute('data-background');
            if (bgUrl) list[i].style.backgroundImage = 'url(' + bgUrl + ')';
        }
    }




    function observeAndInitTextInvert() {
        var list = document.querySelectorAll(".xo_text_invert");
        if (list.length === 0) return;

        function run() {
            if (typeof SplitText === "undefined" || typeof gsap === "undefined") return;
            var split = new SplitText(".xo_text_invert", {
                type: "lines"
            });
            for (var i = 0; i < split.lines.length; i++) {
                var target = split.lines[i];
                gsap.to(target, {
                    backgroundPositionX: 0,
                    ease: "none",
                    scrollTrigger: {
                        trigger: target,
                        scrub: 1,
                        start: 'top 85%',
                        end: "bottom center"
                    },
                });
            }
        }

        function start() {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(run);
            } else {
                run();
            }
        }
        if (typeof IntersectionObserver !== "undefined") {
            var io = new IntersectionObserver(function(entries) {
                if (!entries[0].isIntersecting) return;
                io.disconnect();
                start();
            }, {
                rootMargin: "80px 0px",
                threshold: 0
            });
            io.observe(list[0]);
        } else {
            start();
        }
    }




})();